import { updateOnboardingServiceApi as generatedUpdateOnboardingServiceApi } from '../generated/onboarding/updateOnboardingService';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingServiceApi = generatedUpdateOnboardingServiceApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingService: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body, serviceId }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            if (draft.services != null) {
              const serviceIndex = draft.services.findIndex((service) => service._id === serviceId);

              if (serviceIndex !== -1 && draft.services[serviceIndex] != null) {
                Object.assign(draft.services[serviceIndex], body);
              }
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingServiceMutation } = updateOnboardingServiceApi;
